
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2dff"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2dff"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9ebM6", function(module, exports) {

$parcel$export(module.exports, "Identify", () => $6b7e8e1624d3d02f$export$e513146db6535bff);
$parcel$export(module.exports, "OrderedIdentifyOperations", () => $6b7e8e1624d3d02f$export$64d36bfa56d27e6a);

var $7WQrb = parcelRequire("7WQrb");

var $8uyOB = parcelRequire("8uyOB");

var $gQTtx = parcelRequire("gQTtx");
var $6b7e8e1624d3d02f$export$e513146db6535bff = /** @class */ function() {
    function Identify() {
        this._propertySet = new Set();
        this._properties = {};
    }
    Identify.prototype.getUserProperties = function() {
        return (0, $7WQrb.__assign)({}, this._properties);
    };
    Identify.prototype.set = function(property, value) {
        this._safeSet($6b7e8e1624d3d02f$export$6df138c24303c801.SET, property, value);
        return this;
    };
    Identify.prototype.setOnce = function(property, value) {
        this._safeSet($6b7e8e1624d3d02f$export$6df138c24303c801.SET_ONCE, property, value);
        return this;
    };
    Identify.prototype.append = function(property, value) {
        this._safeSet($6b7e8e1624d3d02f$export$6df138c24303c801.APPEND, property, value);
        return this;
    };
    Identify.prototype.prepend = function(property, value) {
        this._safeSet($6b7e8e1624d3d02f$export$6df138c24303c801.PREPEND, property, value);
        return this;
    };
    Identify.prototype.postInsert = function(property, value) {
        this._safeSet($6b7e8e1624d3d02f$export$6df138c24303c801.POSTINSERT, property, value);
        return this;
    };
    Identify.prototype.preInsert = function(property, value) {
        this._safeSet($6b7e8e1624d3d02f$export$6df138c24303c801.PREINSERT, property, value);
        return this;
    };
    Identify.prototype.remove = function(property, value) {
        this._safeSet($6b7e8e1624d3d02f$export$6df138c24303c801.REMOVE, property, value);
        return this;
    };
    Identify.prototype.add = function(property, value) {
        this._safeSet($6b7e8e1624d3d02f$export$6df138c24303c801.ADD, property, value);
        return this;
    };
    Identify.prototype.unset = function(property) {
        this._safeSet($6b7e8e1624d3d02f$export$6df138c24303c801.UNSET, property, (0, $8uyOB.UNSET_VALUE));
        return this;
    };
    Identify.prototype.clearAll = function() {
        // When clear all happens, all properties are unset. Reset the entire object.
        this._properties = {};
        this._properties[$6b7e8e1624d3d02f$export$6df138c24303c801.CLEAR_ALL] = (0, $8uyOB.UNSET_VALUE);
        return this;
    };
    // Returns whether or not this set actually worked.
    Identify.prototype._safeSet = function(operation, property, value) {
        if (this._validate(operation, property, value)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            var userPropertyMap = this._properties[operation];
            if (userPropertyMap === undefined) {
                userPropertyMap = {};
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                this._properties[operation] = userPropertyMap;
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            userPropertyMap[property] = value;
            this._propertySet.add(property);
            return true;
        }
        return false;
    };
    Identify.prototype._validate = function(operation, property, value) {
        if (this._properties[$6b7e8e1624d3d02f$export$6df138c24303c801.CLEAR_ALL] !== undefined) // clear all already set. Skipping operation;
        return false;
        if (this._propertySet.has(property)) // Property already used. Skipping operation
        return false;
        if (operation === $6b7e8e1624d3d02f$export$6df138c24303c801.ADD) return typeof value === 'number';
        if (operation !== $6b7e8e1624d3d02f$export$6df138c24303c801.UNSET && operation !== $6b7e8e1624d3d02f$export$6df138c24303c801.REMOVE) return (0, $gQTtx.isValidProperties)(property, value);
        return true;
    };
    return Identify;
}();
var $6b7e8e1624d3d02f$export$6df138c24303c801;
(function(IdentifyOperation) {
    // Base Operations to set values
    IdentifyOperation["SET"] = "$set";
    IdentifyOperation["SET_ONCE"] = "$setOnce";
    // Operations around modifying existing values
    IdentifyOperation["ADD"] = "$add";
    IdentifyOperation["APPEND"] = "$append";
    IdentifyOperation["PREPEND"] = "$prepend";
    IdentifyOperation["REMOVE"] = "$remove";
    // Operations around appending values *if* they aren't present
    IdentifyOperation["PREINSERT"] = "$preInsert";
    IdentifyOperation["POSTINSERT"] = "$postInsert";
    // Operations around removing properties/values
    IdentifyOperation["UNSET"] = "$unset";
    IdentifyOperation["CLEAR_ALL"] = "$clearAll";
})($6b7e8e1624d3d02f$export$6df138c24303c801 || ($6b7e8e1624d3d02f$export$6df138c24303c801 = {}));
var $6b7e8e1624d3d02f$export$64d36bfa56d27e6a = [
    $6b7e8e1624d3d02f$export$6df138c24303c801.CLEAR_ALL,
    $6b7e8e1624d3d02f$export$6df138c24303c801.UNSET,
    $6b7e8e1624d3d02f$export$6df138c24303c801.SET,
    $6b7e8e1624d3d02f$export$6df138c24303c801.SET_ONCE,
    $6b7e8e1624d3d02f$export$6df138c24303c801.ADD,
    $6b7e8e1624d3d02f$export$6df138c24303c801.APPEND,
    $6b7e8e1624d3d02f$export$6df138c24303c801.PREPEND,
    $6b7e8e1624d3d02f$export$6df138c24303c801.PREINSERT,
    $6b7e8e1624d3d02f$export$6df138c24303c801.POSTINSERT,
    $6b7e8e1624d3d02f$export$6df138c24303c801.REMOVE
];

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $5c96a02c592fcff1$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $5c96a02c592fcff1$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $5c96a02c592fcff1$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $5c96a02c592fcff1$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $5c96a02c592fcff1$export$1216008129fb82ed);
$parcel$export(module.exports, "__await", () => $5c96a02c592fcff1$export$10c90e4f7922046c);
$parcel$export(module.exports, "__asyncGenerator", () => $5c96a02c592fcff1$export$e427f37a30a4de9b);
$parcel$export(module.exports, "__asyncValues", () => $5c96a02c592fcff1$export$e3b29a3d6162315f);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});

parcelRegister("8uyOB", function(module, exports) {

$parcel$export(module.exports, "UNSET_VALUE", () => $62ec21a270bb21e8$export$a3f337ba59dc3dca);
$parcel$export(module.exports, "AMPLITUDE_PREFIX", () => $62ec21a270bb21e8$export$34512634d73abf96);
$parcel$export(module.exports, "STORAGE_PREFIX", () => $62ec21a270bb21e8$export$7cc65d02ca2e18ec);
$parcel$export(module.exports, "DEFAULT_INSTANCE_NAME", () => $62ec21a270bb21e8$export$beb3c3946c248b94);
$parcel$export(module.exports, "AMPLITUDE_SERVER_URL", () => $62ec21a270bb21e8$export$29e80e090bc2cfd4);
$parcel$export(module.exports, "EU_AMPLITUDE_SERVER_URL", () => $62ec21a270bb21e8$export$2fcb1c10f7306bcf);
$parcel$export(module.exports, "AMPLITUDE_BATCH_SERVER_URL", () => $62ec21a270bb21e8$export$c567544fea55e004);
$parcel$export(module.exports, "EU_AMPLITUDE_BATCH_SERVER_URL", () => $62ec21a270bb21e8$export$68967a892545fca0);
$parcel$export(module.exports, "UTM_CAMPAIGN", () => $62ec21a270bb21e8$export$926599dcfe1d591d);
$parcel$export(module.exports, "UTM_CONTENT", () => $62ec21a270bb21e8$export$76cba99ea272772);
$parcel$export(module.exports, "UTM_ID", () => $62ec21a270bb21e8$export$5061a1cefb237161);
$parcel$export(module.exports, "UTM_MEDIUM", () => $62ec21a270bb21e8$export$a6f5c6056c876f92);
$parcel$export(module.exports, "UTM_SOURCE", () => $62ec21a270bb21e8$export$f7522a6e1839b3b9);
$parcel$export(module.exports, "UTM_TERM", () => $62ec21a270bb21e8$export$74173cb2cd2c2b01);
$parcel$export(module.exports, "DCLID", () => $62ec21a270bb21e8$export$d7046fa8a8c432a0);
$parcel$export(module.exports, "FBCLID", () => $62ec21a270bb21e8$export$bee91738abba7f50);
$parcel$export(module.exports, "GBRAID", () => $62ec21a270bb21e8$export$bba55cdc82bf1e23);
$parcel$export(module.exports, "GCLID", () => $62ec21a270bb21e8$export$d72e6377dae42b4f);
$parcel$export(module.exports, "KO_CLICK_ID", () => $62ec21a270bb21e8$export$9ed7c4aa246186b5);
$parcel$export(module.exports, "LI_FAT_ID", () => $62ec21a270bb21e8$export$e495e049f5a59ccc);
$parcel$export(module.exports, "MSCLKID", () => $62ec21a270bb21e8$export$f912492c0955f678);
$parcel$export(module.exports, "RDT_CID", () => $62ec21a270bb21e8$export$f1d48c95a869863d);
$parcel$export(module.exports, "TTCLID", () => $62ec21a270bb21e8$export$89d66d2933b92df);
$parcel$export(module.exports, "TWCLID", () => $62ec21a270bb21e8$export$856b82f6063e22ef);
$parcel$export(module.exports, "WBRAID", () => $62ec21a270bb21e8$export$b5b43be4e547ddd3);
$parcel$export(module.exports, "BASE_CAMPAIGN", () => $62ec21a270bb21e8$export$ea7354d30dfda3a2);
$parcel$export(module.exports, "SAFE_HEADERS", () => $62ec21a270bb21e8$export$a52b450c7f480d9a);
$parcel$export(module.exports, "FORBIDDEN_HEADERS", () => $62ec21a270bb21e8$export$ac363e6ffe994c89);
var $62ec21a270bb21e8$export$a3f337ba59dc3dca = '-';
var $62ec21a270bb21e8$export$34512634d73abf96 = 'AMP';
var $62ec21a270bb21e8$export$7cc65d02ca2e18ec = "".concat($62ec21a270bb21e8$export$34512634d73abf96, "_unsent");
var $62ec21a270bb21e8$export$beb3c3946c248b94 = '$default_instance';
var $62ec21a270bb21e8$export$29e80e090bc2cfd4 = 'https://api2.amplitude.com/2/httpapi';
var $62ec21a270bb21e8$export$2fcb1c10f7306bcf = 'https://api.eu.amplitude.com/2/httpapi';
var $62ec21a270bb21e8$export$c567544fea55e004 = 'https://api2.amplitude.com/batch';
var $62ec21a270bb21e8$export$68967a892545fca0 = 'https://api.eu.amplitude.com/batch';
var $62ec21a270bb21e8$export$926599dcfe1d591d = 'utm_campaign';
var $62ec21a270bb21e8$export$76cba99ea272772 = 'utm_content';
var $62ec21a270bb21e8$export$5061a1cefb237161 = 'utm_id';
var $62ec21a270bb21e8$export$a6f5c6056c876f92 = 'utm_medium';
var $62ec21a270bb21e8$export$f7522a6e1839b3b9 = 'utm_source';
var $62ec21a270bb21e8$export$74173cb2cd2c2b01 = 'utm_term';
var $62ec21a270bb21e8$export$d7046fa8a8c432a0 = 'dclid';
var $62ec21a270bb21e8$export$bee91738abba7f50 = 'fbclid';
var $62ec21a270bb21e8$export$bba55cdc82bf1e23 = 'gbraid';
var $62ec21a270bb21e8$export$d72e6377dae42b4f = 'gclid';
var $62ec21a270bb21e8$export$9ed7c4aa246186b5 = 'ko_click_id';
var $62ec21a270bb21e8$export$e495e049f5a59ccc = 'li_fat_id';
var $62ec21a270bb21e8$export$f912492c0955f678 = 'msclkid';
var $62ec21a270bb21e8$export$f1d48c95a869863d = 'rdt_cid';
var $62ec21a270bb21e8$export$89d66d2933b92df = 'ttclid';
var $62ec21a270bb21e8$export$856b82f6063e22ef = 'twclid';
var $62ec21a270bb21e8$export$b5b43be4e547ddd3 = 'wbraid';
var $62ec21a270bb21e8$export$4c723243179776e1 = 'EMPTY';
var $62ec21a270bb21e8$export$ea7354d30dfda3a2 = {
    utm_campaign: undefined,
    utm_content: undefined,
    utm_id: undefined,
    utm_medium: undefined,
    utm_source: undefined,
    utm_term: undefined,
    referrer: undefined,
    referring_domain: undefined,
    dclid: undefined,
    gbraid: undefined,
    gclid: undefined,
    fbclid: undefined,
    ko_click_id: undefined,
    li_fat_id: undefined,
    msclkid: undefined,
    rdt_cid: undefined,
    ttclid: undefined,
    twclid: undefined,
    wbraid: undefined
};
var $62ec21a270bb21e8$export$8ee5ccb4ef82a40e = 'MKTG';
var $62ec21a270bb21e8$export$a52b450c7f480d9a = [
    'access-control-allow-origin',
    'access-control-allow-credentials',
    'access-control-expose-headers',
    'access-control-max-age',
    'access-control-allow-methods',
    'access-control-allow-headers',
    'accept-patch',
    'accept-ranges',
    'age',
    'allow',
    'alt-svc',
    'cache-control',
    'connection',
    'content-disposition',
    'content-encoding',
    'content-language',
    'content-length',
    'content-location',
    'content-md5',
    'content-range',
    'content-type',
    'date',
    'delta-base',
    'etag',
    'expires',
    'im',
    'last-modified',
    'link',
    'location',
    'permanent',
    'p3p',
    'pragma',
    'proxy-authenticate',
    'public-key-pins',
    'retry-after',
    'server',
    'status',
    'strict-transport-security',
    'trailer',
    'transfer-encoding',
    'tk',
    'upgrade',
    'vary',
    'via',
    'warning',
    'www-authenticate',
    'x-b3-traceid',
    'x-frame-options'
];
var $62ec21a270bb21e8$export$ac363e6ffe994c89 = [
    'authorization',
    'cookie',
    'set-cookie'
];

});

parcelRegister("gQTtx", function(module, exports) {

$parcel$export(module.exports, "isValidObject", () => $c44c88eb25e506de$export$16a0268bc22b47b0);
$parcel$export(module.exports, "isValidProperties", () => $c44c88eb25e506de$export$194dd9a8a66065f3);

var $7WQrb = parcelRequire("7WQrb");
var $c44c88eb25e506de$var$MAX_PROPERTY_KEYS = 1000;
var $c44c88eb25e506de$export$16a0268bc22b47b0 = function(properties) {
    if (Object.keys(properties).length > $c44c88eb25e506de$var$MAX_PROPERTY_KEYS) return false;
    for(var key in properties){
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        var value = properties[key];
        if (!$c44c88eb25e506de$export$194dd9a8a66065f3(key, value)) return false;
    }
    return true;
};
var $c44c88eb25e506de$export$194dd9a8a66065f3 = function(property, value) {
    var e_1, _a;
    if (typeof property !== 'string') return false;
    if (Array.isArray(value)) {
        var isValid = true;
        try {
            for(var value_1 = (0, $7WQrb.__values)(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()){
                var valueElement = value_1_1.value;
                if (Array.isArray(valueElement)) return false;
                else if (typeof valueElement === 'object') isValid = isValid && $c44c88eb25e506de$export$16a0268bc22b47b0(valueElement);
                else if (![
                    'number',
                    'string'
                ].includes(typeof valueElement)) return false;
                if (!isValid) return false;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (value_1_1 && !value_1_1.done && (_a = value_1.return)) _a.call(value_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    } else if (value === null || value === undefined) return false;
    else if (typeof value === 'object') // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return $c44c88eb25e506de$export$16a0268bc22b47b0(value);
    else if (![
        'number',
        'string',
        'boolean'
    ].includes(typeof value)) return false;
    return true;
};

});


parcelRegister("ehkhH", function(module, exports) {
module.exports = import("hP8nK").then(()=>parcelRequire('dOups'));

});


var $9ebM6 = parcelRequire("9ebM6");
const $c10fc4dd470a6ad9$export$1751d865e672c7d5 = '31e31b857ff7ab2051dc75c823b8512c';
const $c10fc4dd470a6ad9$export$5cd3cf0adfc46395 = 'tg';


const $018b4aedef670f2f$export$934f5750fad9216a = 'appsflyerId';
let $018b4aedef670f2f$var$amplitudeAnalytics = null;

const $018b4aedef670f2f$var$loadAmplitudeAnalytics = async ()=>{
    if (!$018b4aedef670f2f$var$amplitudeAnalytics) $018b4aedef670f2f$var$amplitudeAnalytics = await (parcelRequire("ehkhH"));
    return $018b4aedef670f2f$var$amplitudeAnalytics;
};
class $018b4aedef670f2f$var$AmplitudeAnalytics {
    apiKey;
    isInitialized = false;
    constructor(apiKey){
        this.apiKey = apiKey;
    }
    async initialize() {
        if (!this.isInitialized) {
            await $018b4aedef670f2f$var$loadAmplitudeAnalytics();
            $018b4aedef670f2f$var$amplitudeAnalytics.init(this.apiKey, {
                defaultTracking: {
                    formInteractions: false,
                    pageViews: false,
                    sessions: true
                }
            });
            this.setAppsflyerId(localStorage.getItem($018b4aedef670f2f$export$934f5750fad9216a) ?? '');
            this.isInitialized = true;
        }
    }
    async setAppsflyerId(id) {
        if (!id) return;
        await this.initialize();
        const identity = new (0, $9ebM6.Identify)().set('appsflyer_id', id);
        $018b4aedef670f2f$var$amplitudeAnalytics.identify(identity);
    }
    async setUser(id) {
        await this.initialize();
        $018b4aedef670f2f$var$amplitudeAnalytics.setUserId(id);
        this.setAppsflyerId(localStorage.getItem($018b4aedef670f2f$export$934f5750fad9216a) ?? '');
    }
    async track(name, data) {
        await this.initialize();
        const packageName = localStorage.getItem('packageName');
        $018b4aedef670f2f$var$amplitudeAnalytics.logEvent(name, {
            ...data,
            ...packageName && {
                package_name: packageName
            }
        });
    }
    async reset() {
        await this.initialize();
        $018b4aedef670f2f$var$amplitudeAnalytics.reset();
    }
}
function $018b4aedef670f2f$export$f0171e3a5f155c2b() {
    const packageName = localStorage.getItem('packageName');
    if (packageName) return 'mobile app';
    if (window.innerWidth < 768) return 'mobile web';
    return 'desktop';
}
function $018b4aedef670f2f$export$da605e7fd8e9771f() {
    return window.location.pathname;
}
var $018b4aedef670f2f$export$2e2bcd8739ae039 = new $018b4aedef670f2f$var$AmplitudeAnalytics((0, $c10fc4dd470a6ad9$export$1751d865e672c7d5));


const $c7a3af612bf434d0$export$95fd5664a53dd0c5 = (paramName)=>{
    const url = window.location.href;
    const urlObject = new URL(url);
    const queryParams = new URLSearchParams(urlObject.search);
    let paramValue = queryParams.get(paramName);
    if (!paramValue) return null;
    try {
        paramValue = decodeURIComponent(paramValue);
    } catch (e) {
        return paramValue;
    }
    try {
        return JSON.parse(paramValue);
    } catch (e) {
        return paramValue;
    }
};



document.addEventListener('DOMContentLoaded', function() {
    if ((0, $c10fc4dd470a6ad9$export$5cd3cf0adfc46395) === 'tg') $281dd37ebcf21b82$var$trackBlockScreen();
});
const $281dd37ebcf21b82$var$trackBlockScreen = ()=>{
    const userTgId = (0, $c7a3af612bf434d0$export$95fd5664a53dd0c5)('userId') ?? (0, $c7a3af612bf434d0$export$95fd5664a53dd0c5)('user')?.id;
    (0, $018b4aedef670f2f$export$2e2bcd8739ae039).track('Authorization_BlockScreen_TG', {
        host_type: (0, $018b4aedef670f2f$export$f0171e3a5f155c2b)(),
        ...userTgId && {
            user_tg_id: userTgId
        }
    });
};


//# sourceMappingURL=geo-blocked.a9cbda3e.js.map
